module.exports = __webpack_public_path__ + "media/images/logo/fakturaonline-square-logo-rs-016eafc898a976b84ceed0f0af1e7817.svg";